<ng-container *ngIf="isDisplayDashboard">
  <div class="app-container">
    <app-sidebar></app-sidebar>
    <div class="main-content">
      <app-topbar></app-topbar>
      <router-outlet></router-outlet>
    </div>
  </div> 
</ng-container>

<ng-container *ngIf="!isDisplayDashboard">
  <div [ngSwitch]="path">
    <app-login *ngSwitchCase="'login'"></app-login>
    <app-register *ngSwitchCase="'register'"></app-register>
    <app-mail-verification *ngSwitchCase="'mail-verification'"></app-mail-verification>
    <app-reset-password *ngSwitchCase="'reset-password'"></app-reset-password>
    <app-forgot-password *ngSwitchCase="'forgot-password'"></app-forgot-password>
    <app-home *ngSwitchCase="'home'"></app-home>
    <app-search-results *ngSwitchCase="'search-results'"></app-search-results>
    <app-bookslot *ngSwitchCase="'bookslot'"></app-bookslot>
    <app-firm-details *ngSwitchCase="'firm'"></app-firm-details>
    <app-checkout *ngSwitchCase="'checkout'"></app-checkout>
    <app-construction *ngSwitchCase="'videoconsult'"></app-construction>
    <app-construction *ngSwitchCase="'legal-verification'"></app-construction>
  </div>
</ng-container>


<!--
--- Respective Modules placed ---

Appointments - Calendar
Documents - Documents
Profile Info - Settings  > ProfileInformation
Chat - Chat
Payment -  Settings  > Subscription

--- Respective Modules placed ---
-->